import { useCallback, useMemo } from "react"

import { useSearchParams } from "wouter"

import { DATE_SEARCH_PARAM_NAME } from "@/config"
import { formatDateForUrl } from "@/utils/dateUtils"

import { parseDateParam } from "../../schemas/urlParamSchemas"

const useDateParam = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const rawDate = searchParams.get(DATE_SEARCH_PARAM_NAME)

  const startDate = useMemo(() => {
    const parsed = parseDateParam(rawDate) ?? new Date()
    if (formatDateForUrl(parsed) < formatDateForUrl(new Date())) {
      return new Date()
    }
    return parsed
  }, [rawDate])

  const setStartDate = useCallback(
    (date: Date) => {
      setSearchParams(
        (prev) => {
          prev.set(DATE_SEARCH_PARAM_NAME, formatDateForUrl(date))
          return prev
        },
        { replace: true }
      )
    },
    [setSearchParams]
  )

  return { startDate, setStartDate }
}

export default useDateParam
